export default __webpack_public_path__ + "static/8-f8bc5736b910819a3f595012ba39de13.png";